<template>
    <v-container class="app-container">
        <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
        <v-row>
            <v-col cols="12" md="3" class="hidden-sm-and-down">

            </v-col>
            <v-col cols="12" md="9">
                <div>
                    <h1 class="text-center" v-if="metaData.header">{{ metaData.header }}</h1>
                    <div v-else>
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                    </div>
                    <v-col cols="12">
                        <div class="skeleton-text-short" v-if="listLoading">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                        </div>
                        <div class="overline text-center" v-else>{{$t('productsFound')}}: {{total}}</div>
                    </v-col>
                    <product-list
                        :loading="listLoading"
                        :products="products"
                        :total="total"
                        :init-page="page"
                        :last-page="lastPage"
                        :is-visible-more-button="loadMore"
                        filter-card-key="region"
                        @show-more="incrementPage"
                        @change-page="setPage"
                    ></product-list>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Breadcrumbs from '../../../app-front/components/breadcrumbs/Breadcrumbs';
    import AppBreadcrumbs from '../../../app-front/mixins/AppBreadcrumbs';
    import Meta from '../../../app-front/mixins/Meta';
    import ProductList from '../../../app-front/components/product/product-list';
    import ProductListSort from '../../../app-front/mixins/ProductListSort';
    import ProductsPagination from '../../../app-front/mixins/ProductsPagination';

    export default {
        name: 'Products',
        components: {
            Breadcrumbs,
            ProductList
        },
        mixins: [
            AppBreadcrumbs,
            Meta,
            ProductListSort,
            ProductsPagination
        ],
        data() {
            return {
                metaUrl: '/products',
            }
        },
        created() {
            this.setProducts();
        },
    }
</script>

<style scoped>

</style>
